import React, { useEffect, useState } from "react";
import api, { apiErrorMessage } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ADMIN_AFF } from "@/constants/testIds";

export default function AdminAffiliateTiers() {
  const { user } = useAuth();
  const isMaster = user?.roles?.includes("master_admin");
  const [tiers, setTiers] = useState([]);
  const [err, setErr] = useState("");
  const [edits, setEdits] = useState({});

  const reload = async () => {
    try { const { data } = await api.get("/admin/affiliate/tiers"); setTiers(data); setEdits({}); }
    catch (e) { setErr(apiErrorMessage(e)); }
  };
  useEffect(() => { reload(); }, []);

  const setField = (key, field, val) => setEdits((e) => ({ ...e, [key]: { ...(e[key] || {}), [field]: val } }));
  const save = async (key) => {
    const patch = edits[key];
    if (!patch) return;
    try { await api.put(`/admin/affiliate/tiers/${encodeURIComponent(key)}`, patch); await reload(); }
    catch (e) { setErr(apiErrorMessage(e)); }
  };

  return (
    <div className="space-y-6">
      <header className="fade-up">
        <div className="eyebrow">Affiliate admin</div>
        <h1 className="headline-xl">Tier thresholds</h1>
        <p className="text-lifted-dim mt-2 text-sm max-w-2xl">Lift-Off → Orbit → Galaxy → Cosmos promotion rules.</p>
      </header>
      {err && <div className="text-rose-300 text-sm">{err}</div>}
      <div data-testid={ADMIN_AFF.tiers} className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {tiers.map((t) => (
          <div key={t.key} className="glass-panel p-5" style={{ borderColor: `${t.color}40` }}>
            <div className="flex items-center justify-between">
              <div className="font-anton text-2xl uppercase" style={{ color: t.color }}>{t.label}</div>
              <span className="chip">order {t.order}</span>
            </div>
            <div className="mt-4 grid grid-cols-2 gap-3">
              <div>
                <label className="lifted-label">Min referrals</label>
                <input type="number" className="input-lifted" defaultValue={t.min_referrals} onChange={(e) => setField(t.key, "min_referrals", parseInt(e.target.value, 10) || 0)} disabled={!isMaster} />
              </div>
              <div>
                <label className="lifted-label">Min volume ($)</label>
                <input type="number" className="input-lifted" defaultValue={(t.min_volume_cents || 0) / 100} onChange={(e) => setField(t.key, "min_volume_cents", Math.round(parseFloat(e.target.value || "0") * 100))} disabled={!isMaster} />
              </div>
            </div>
            <button onClick={() => save(t.key)} disabled={!isMaster || !edits[t.key]} className="btn-lifted mt-4 !text-[0.7rem] disabled:opacity-40">Save</button>
          </div>
        ))}
      </div>
    </div>
  );
}
